<template>
  <CompanyWrapper>
    <CommonHowToJoin></CommonHowToJoin>
  </CompanyWrapper>
</template>

<script>
import CompanyWrapper from "../../../../components/sp/company/CompanyWrapper";
import CommonHowToJoin from "../../../../components/sp/howtojoin/CommonHowToJoin";
export default {
  components: {
    CompanyWrapper,
    CommonHowToJoin,
  },
  name: "HowToJoin",
};
</script>



// WEBPACK FOOTER //
// src/pages/sp/company/howtojoin/HowToJoin.vue